import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../Hooks/useStore";

export type SeenNotificationInitialState = {
  seen: boolean;
};
const initialState = {
  seen: false,
} as SeenNotificationInitialState;

export const seenNotificationSlice = createSlice({
  name: "seenNotificationSlice",
  reducers: {
    setSeenNotifications: (state, action: PayloadAction<boolean>) => {
      state.seen = action.payload;
    },
  },
  initialState,
});

export const useSeenNotification = () => {
  const { seen } = useAppSelector((state) => state.seenNotification);

  return {
    seen,
  };
};

export const { setSeenNotifications } = seenNotificationSlice.actions || {};

export default seenNotificationSlice.reducer;
